import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { AutoComplete } from "antd";
import { searchOceanPortLocations } from "../../store/ManualQuote/OceanManualQuoteSlice";

const DEBOUNCE_MS = 350;
const MIN_CHARS = 2;

const INPUT_CLS =
  "h-[42px] px-3.5 focus:outline-none block w-full text-sm border border-gray-200 rounded-xl text-gray-800 bg-white transition-colors focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 hover:border-gray-300 disabled:bg-gray-50 disabled:text-gray-400 disabled:border-gray-100 disabled:cursor-not-allowed disabled:hover:border-gray-100";

const portLabel = (p) => (p?.port_code ? `${p.port_name} - (${p.port_code})` : p?.port_name);

// Type-ahead port/location field backed by
// GET ocean-manual-quote/get-locations?query=...&locationType=origin|destination.
// Uses AutoComplete rather than Select on purpose — it behaves like a plain
// text input (typing directly sets the field value), and only *offers*
// matches from the API as a dropdown; it never blocks the user from typing
// something that doesn't match anything and moving on.
const AsyncPortSelect = ({ name, value, setFieldValue, placeholder, disabled, locationType, width = "100%" }) => {
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const debounceRef = useRef(null);

  const runSearch = (text) => {
    dispatch(searchOceanPortLocations({ query: text, locationType })).then((res) => {
      const rows = res?.payload?.data?.data || res?.payload?.data || [];
      setOptions(rows.map((p) => ({ value: p?.port_name, label: portLabel(p) })));
    });
  };

  const handleSearch = (text) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!text || text.trim().length < MIN_CHARS) {
      setOptions([]);
      return;
    }
    debounceRef.current = setTimeout(() => runSearch(text.trim()), DEBOUNCE_MS);
  };

  return (
    <AutoComplete
      value={value || ""}
      options={options}
      onSearch={handleSearch}
      onChange={(val) => setFieldValue(name, val)}
      onSelect={(val) => setFieldValue(name, val)}
      disabled={disabled}
      filterOption={false}
      style={{ width }}
      popupMatchSelectWidth={false}
    >
      <input type="text" placeholder={placeholder} className={INPUT_CLS} />
    </AutoComplete>
  );
};

export default AsyncPortSelect;
